import { useState } from "react";
import { useParams } from "react-router-dom";
import useTheme from "../hook/useTheme";
import { useEffect } from "react";
import Loading from "../components/autoagendamientov2/Loading";
import ClbForm from "../components/autoagendamientov2/colombia/ClbForm";
import ClbEspecialidad from "../components/autoagendamientov2/colombia/ClbEspecialidad";
import ClbConfirmarServicio from "../components/autoagendamientov2/colombia/ClbConfirmarServicio";
import CardDinamic from "../components/autoagendamientov2/CardDinamic";
import {
  buttonFailPayment,
  buttonPaid,
  buttonPending,
  buttonReload,
  declinadoConsentimientoTLS,
  reservadoNoCopayment,
} from "./autoagendamiento/AutoagendamientoV2";
import Banner1 from "../components/autoagendamientov2/Banner1";
import Banner2 from "../components/autoagendamientov2/Banner2";
import { ThemeProvider } from "styled-components";
import { AutoagendamientoV2Styles } from "../theme/AutoagendamientoV2Styles";
import HeaderTop from "../components/autoagendamientov2/HeaderTop";
import { Container } from "react-bootstrap";
import AutoagendmientoFooter from "../components/autoagendamientov2/AutoagendmientoFooter";
import { BASE_URL_WS, GET_ACCOUNT_SIN_TOKEN } from "../api/Routes";
import Get from "../api/Get";
import { initData } from "../components/autoagendamientov2/data/contants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import SockJsClient from "react-stomp";

const AgendamientoCuentaV2 = () => {
  const history = useHistory();
  const { idAccount } = useParams();
  const { theme } = useTheme("defaultv2");
  const [currentScreen, setCurrentScreen] = useState("loading");
  const [currentBanner, setCurrentBanner] = useState("");
  const [dataHelp, setDataHelp] = useState({
    patient: null,
    validLink: true,
    startMeeting: null,
    currentTime: null,
    clientTime: Date.now(),
    reservadoExitosamente: false,
    isPedienteAprobacion: false,
    notEdit: false,
    fieldSettings: [],
    declined: false,
    source: "flujoallianz",
    configuration: null,
    payment: null,
    paymentStatus: "currentflow",
    linkAllianz: true,
  });
  //configuration account data(styles and data to the steps realted to the account)
  const [configuration, setConfiguration] = useState(null);
  //payments
  const [payment, setPayment] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState("currentflow");

  const screens = {
    loading: (
      <div className="p-5 text-center">
        <Loading />
      </div>
    ),
    clbFormPatient: (
      <ClbForm
        classTop="mt--20"
        data={dataHelp}
        setData={setDataHelp}
        setCurrentScreen={setCurrentScreen}
        setConfiguration={setConfiguration}
      />
    ),
    clbEspecialidad: (
      <ClbEspecialidad
        classTop="mt--20"
        data={dataHelp}
        setData={setDataHelp}
        setCurrentScreen={setCurrentScreen}
      />
    ),
    clbConfirmarServicio: (
      <ClbConfirmarServicio
        classTop="mt--20"
        data={dataHelp}
        setData={setDataHelp}
        setCurrentScreen={setCurrentScreen}
        configuration={configuration}
        setPayment={setPayment}
        setPaymentStatus={setPaymentStatus}
      />
    ),
    declinadoConsentimientoTLS: (
      <CardDinamic children={declinadoConsentimientoTLS}></CardDinamic>
    ),
    DECLINED: <CardDinamic children={buttonReload}></CardDinamic>,
    PENDING: <CardDinamic children={buttonPending}></CardDinamic>,
    PAID: <CardDinamic children={buttonPaid}></CardDinamic>,
    failPayment: <CardDinamic children={buttonFailPayment}></CardDinamic>,
    reservadoNoCopayment: (
      <CardDinamic children={reservadoNoCopayment(configuration)}></CardDinamic>
    ),
    noExisteCompania: <CardDinamic children={noExisteCompania}></CardDinamic>,
  };
  const banners = {
    banner1: <Banner1 />,
    banner2: <Banner2 />,
  };

  useEffect(() => {
    if (
      currentScreen === "mexFormPatient" ||
      currentScreen === "clbFormPatient"
    ) {
      setCurrentBanner("banner2");
    } else if (
      currentScreen === "mexEspecialidad" ||
      currentScreen === "confirmarServicio" ||
      currentScreen === "clbEspecialidad" ||
      currentScreen === "clbConfirmarServicio"
    ) {
      setCurrentBanner("banner1");
    } else {
      setCurrentBanner("");
    }
  }, [currentScreen]);

  //buscar el account
  useEffect(() => {
    let doFecth = true;
    if (parseInt(idAccount) === 57) {
      //setTheme(themes.data.allianz);
      history.replace("/public/agendamiento/cuenta/allianz/57");
      setDataHelp((prev) => ({
        ...prev,
        source: "flujoallianz",
      }));
    } else if (parseInt(idAccount) === 68) {
      setDataHelp((prev) => ({
        ...prev,
        source: "autoagendamientovardi",
      }));
    } else if (parseInt(idAccount) === 144) {
      setDataHelp((prev) => ({
        ...prev,
        source: "autoagendamientonuevoeps",
      }));
    }

    const fecthApi = async () => {
      try {
        const response = await Get({
          url: `${GET_ACCOUNT_SIN_TOKEN}/${idAccount}`,
          noToken: true,
        });
        if (response.data.state) {
          setDataHelp((prev) => ({
            ...prev,
            patient: {
              ...initData,
              account: response.data.data,
            },
          }));
          setCurrentScreen("clbFormPatient");
        } else {
          setCurrentScreen("noExisteCompania");
        }
      } catch (error) {
        setCurrentScreen("noExisteCompania");
      }
    };
    if (doFecth) fecthApi();
  }, [idAccount, history]);

  //checar payment status
  useEffect(() => {
    if (paymentStatus === "DECLINED") {
      setCurrentScreen("DECLINED");
    } else if (paymentStatus === "PENDING") {
      setCurrentScreen("PENDING");
    } else if (paymentStatus === "PAID") {
      setCurrentScreen("PAID");
    }
  }, [paymentStatus]);

  const handleMessageSocket = (message) => {
    setPaymentStatus(message);
  };

  return (
    <ThemeProvider theme={theme}>
      <AutoagendamientoV2Styles />
      <div className="body-1">
        <HeaderTop company={dataHelp.patient?.account?.partner?.company} />
        {banners[currentBanner]}
        <main>
          <Container>{screens[currentScreen]}</Container>
        </main>
        <AutoagendmientoFooter cita={dataHelp.patient} />
        {payment && (
          <SockJsClient
            url={`${BASE_URL_WS}/ws`}
            topics={[`/user/${payment.id}/queue/paymentStatus`]}
            onMessage={(message) => handleMessageSocket(message)}
          />
        )}
      </div>
    </ThemeProvider>
  );
};

export default AgendamientoCuentaV2;

const noExisteCompania = (
  <div>
    <p>
      Esta intenando acceder a un link sin información, revise la información y
      vuelve a intentarlo por favor.
    </p>
  </div>
);
